import { OAUTH_NO_ACCOUNT_PARAM } from '../../shared/constants.js';

/**
 * Whether the server put the parameter on the URL after a Google sign-in for an address without an account
 * (server/utils/google-sign-helper.ts). Read once on mount, then {@link removeOAuthNoAccountParam}.
 */
export function peekOAuthNoAccount(): boolean {
  return new URLSearchParams(window.location.search).has(OAUTH_NO_ACCOUNT_PARAM);
}

/** Drops the parameter so a reload does not show the notice again. */
export function removeOAuthNoAccountParam(): void {
  const url = new URL(window.location.href);
  if (!url.searchParams.has(OAUTH_NO_ACCOUNT_PARAM)) return;
  url.searchParams.delete(OAUTH_NO_ACCOUNT_PARAM);
  window.history.replaceState(window.history.state, '', url.toString());
}
